import React from 'react';
import { useAccounts } from '../context/AccountContext';
import { useTranslation } from "react-i18next";
import { LockStatusResult } from '../types/models';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { Text } from '@uhg-abyss/web/ui/Text';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';
import { Card } from '@uhg-abyss/web/ui/Card';
import { ScreenQueries, styled } from '@uhg-abyss/web/tools/styled';

const LockStatusWrapper = styled('div', {
    padding: '1rem',
    margin: '0.25rem',
});

const StatusIconContainer = styled('div', {
    paddingRight: '24px',
});

const StatusHeading = styled(Heading, {
    [ScreenQueries.SmallerThanMedium]: {
        fontSize: 'var(--abyss-fontSizes-web-core-fontSize-h-mobile-40)',
    }
});

export const LockStatus = () => {
    const { t, i18n } = useTranslation();
    const { lockStatus, selectedAccount } = useAccounts();

    const domainName = selectedAccount?.resourceName ?? 'MS';

    return (
        <div>
            {lockStatus !== LockStatusResult.Error &&
                <Layout.Stack alignLayout="center">
                    <LockStatusWrapper>
                        <Card
                            css={{
                                '&.abyss-card-root': {
                                    boxShadow: '0px 2px 4px 0px rgba(203, 204, 205, 1)',
                                    borderRadius: 5,
                                },
                            }}
                        >
                            <div style={{ padding: '16px 40px' }}>
                                {
                                    (lockStatus === LockStatusResult.Pending) &&
                                    <Layout.Group alignLayout="center">
                                        <StatusIconContainer>
                                            <LoadingSpinner ariaLoadingLabel={t('checkingPasswordStatusMsg', { domainName })} size="lg" isLoading={lockStatus === LockStatusResult.Pending} color="$warning1" />
                                        </StatusIconContainer>
                                        <div>
                                            <StatusHeading
                                                id="checkingPasswordStatusMsg"
                                                level={4}
                                                color="black"
                                            >
                                                {t('checkingPasswordStatusMsg', { domainName })}
                                            </StatusHeading>
                                        </div>
                                    </Layout.Group>

                                }
                                {
                                    (lockStatus === LockStatusResult.Unlocked) &&
                                    <Layout.Group alignLayout="center">
                                        <StatusIconContainer>
                                            <img src="Lock.svg" alt="Lock" />
                                        </StatusIconContainer>
                                        <div>
                                            <StatusHeading id="passwordUnlockMsg1" level={4} color="$warning1">{t('passwordUnlockMsg1', { domainName })}</StatusHeading>
                                            <StatusHeading id="passwordUnlockMsg2" level={4} color="$warning1">{t('passwordUnlockMsg2')}</StatusHeading>
                                        </div>
                                    </Layout.Group>
                                }
                                {
                                    (lockStatus === LockStatusResult.NoAction) &&
                                    <Layout.Group alignLayout="center">
                                        <StatusIconContainer>
                                            <img src="UnLock.svg" alt="Unlock" />
                                        </StatusIconContainer>
                                        <div>
                                            <StatusHeading id="passwordNotLockedMsg1" level={4} color="$info1">{t('passwordNotLockedMsg1', { domainName })}</StatusHeading>
                                            <Text data-testid="passwordNotLockedMsg2" color="$textPrimary">{t('passwordNotLockedMsg2')}</Text>
                                        </div>
                                    </Layout.Group>
                                }
                            </div>
                        </Card>
                    </LockStatusWrapper>
                </Layout.Stack>
            }
        </div>
    );
}